import { useState, useEffect, useCallback } from "react";

interface Opts {
  mobileSize?: number;
}

export function useIsDesktop(opts?: Opts): boolean {
  const [isDesktop, setIsDesktop] = useState(false);
  const screenSizeToCheck = opts?.mobileSize || 996;

  const resizeFn = useCallback(() => {
    if (
      typeof window !== "undefined" &&
      window.innerWidth > screenSizeToCheck
    ) {
      setIsDesktop(true);
    } else {
      setIsDesktop(false);
    }
  }, [setIsDesktop, screenSizeToCheck]);

  // Add event listener for window resize.
  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener("resize", resizeFn);
    }
  }, [resizeFn]);

  // Initial check if the user is on a desktop.
  useEffect(() => {
    if (
      typeof window !== "undefined" &&
      window.innerWidth > screenSizeToCheck
    ) {
      setIsDesktop(true);
    }
  }, []);

  return isDesktop;
}
